import React, { useState } from "react";

const Unsubscribe = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = { emailAddress: email };

    alert("Unsubscribed. We're sorry to let you go.");

    try {
      const response = await fetch(
        "https://ofc-newsletter.onrender.com/api/delete/json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setEmail("");
      } else {
        throw new Error("Failed to unsubscribe");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        background:
          "linear-gradient(135deg, var(--gradient-start), var(--gradient-end))",
      }}
    >
      <div className="subscribe-form" id="subscribe">
        <form onSubmit={handleSubmit}>
          <p>We're sorry to let you go...</p>
          <input
            type="email"
            placeholder="Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Unsubscribe</button>
        </form>
      </div>
    </div>
  );
};

export default Unsubscribe;
